import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import API from "../../services/axiosInstance";
import './role.css'
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import { FormLoader, useFormLoader } from "../common_modules/loader";
import usePreventMultiClick from "../utils/SubmitPrevent";

const CreateUserRole = () => {
    const [permissionGroups, setPermissionGroups] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const [openKeys, setOpenKeys] = useState([]);
    const [forceUpdate, setForceUpdate] = useState(false);

    const handleToggle = (eventKey) => {
        setOpenKeys(current =>
            current.includes(eventKey)
                ? current.filter(k => k !== eventKey)
                : [...current, eventKey]
        );
    };

    const { id } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook
    const { btnClicked, setBtnClicked } = usePreventMultiClick();

    const { handleSubmit, register, setValue, watch, formState: { errors } } = useForm({
        defaultValues: {
            name: "",
            accountType: "",
            permissions: []
        }
    });

    // Watch permissions to check if ALL PERMISSIONS is selected
    const watchedPermissions = watch("permissions");

    // Check if any permission from "ALL PERMISSIONS" group is selected
    const allPermissionsGroup = permissionGroups.find(g => g.moduleName === "ALL PERMISSIONS");
    const isAllPermissionsSelected = allPermissionsGroup?.permissions?.some(item =>
        watchedPermissions?.includes(JSON.stringify(item))
    );

    const visibleGroups = isAllPermissionsSelected
        ? permissionGroups.filter(g => g.moduleName === "ALL PERMISSIONS")
        : permissionGroups;

    const permissionList = async () => {
        startLoading();
        try {
            const endpoint = id ?
                `/tech/roles/set/by/id/${id}` :
                `/tech/roles/permission/list`;
            const response = await API.get(endpoint);
            const data = id ?
                response.data.data.list :
                response.data.data;

            const sortedData = data.sort((a, b) => {
                if (a.moduleName === "ALL PERMISSIONS") return -1;
                if (b.moduleName === "ALL PERMISSIONS") return 1;
                return a.moduleName.localeCompare(b.moduleName);
            });

            setPermissionGroups(sortedData);

            if (id) {
                const checkedPermission =
                    sortedData.flatMap(item => item.permissions)
                        .filter(c => c.checked == true)
                        .map(v => JSON.stringify(v));
                setValue("name", response.data.data.roleSetName);
                setValue("accountType", response.data.data.accountType);
                setValue("permissions", checkedPermission);
            }
        } catch (error) { } finally {
            stopLoading();
        }
    }

    const onSubmit = async (data) => {
        if(btnClicked) return;
        setBtnClicked(true);
        startLoading();
        let allPerSelected = undefined;
        if (data) {
            data[`permissions`] = data.permissions.map((item, i) => {
                let a = JSON.parse(item);
                if (a.permission == "fullAccess") {
                    allPerSelected = i;
                }
                return a;
            });

            // if user select all permission
            if (allPerSelected > -1) {
                data[`permissions`] = [data.permissions[allPerSelected]]
            }

            try {
                data.permissions.forEach(a => a[`checked`] = true);
                let response = null;
                if (id) {
                    response = await API.put(`/tech/roles/set/update/${id}/${forceUpdate}`, data)
                } else {
                    response = await API.post('/tech/roles/set/save', data)
                }
                if (response.status == 200) {
                    alert(`${id ? "Updated" : "Saved"} Successfully...`);
                    redirect();
                }
            } catch (error) { console.log(error); } finally {
                setBtnClicked(false);
                stopLoading();
            }
        }
    }

    const userAccountList = async () => {
        startLoading();
        try {
            const accTypeRes = await API.get('tech/users/user/accounts/list');
            if (accTypeRes.status === 200) {
                permissionList();
                setAccountList(accTypeRes?.data?.data);
            }
        } catch (error) {

        } finally {
            stopLoading();
        }
    }

    function CustomToggle({ children, onToggle, isOpen }) {
        return (
            <button
                type="button"
                onClick={onToggle}
                className="addUserRole"
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {children}
                <span>{isOpen ? '▼' : '▶'}</span>
            </button>
        );
    }

    const redirect = () => {
        if (state?.redirectPage) {
            navigate(state?.redirectPage)
        } else {
            navigate("/role");
        }
    }

    useEffect(() => {
        userAccountList();
        setOpenKeys(id ? [] : ["0"]);
    }, []);

    useEffect(() => {
        const keysToOpen = [];
        permissionGroups.forEach((group, index) => {
            const hasChecked = group.permissions.some(item => item.checked);
            if (hasChecked) {
                keysToOpen.push(index.toString());
            }
        });
        setOpenKeys(current => {
            const merged = [...new Set([...current, ...keysToOpen])];
            return merged;
        });
    }, [permissionGroups]);

    // When ALL PERMISSIONS is selected auto open its card (index 0), close others
    // When deselected restore all cards open
    // useEffect(() => {
    //     if (isAllPermissionsSelected) {
    //         setOpenKeys(["0"]); // "ALL PERMISSIONS" is always index 0 after sort
    //     }
    // }, [isAllPermissionsSelected]);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <span>Tech Admin</span>
                <Link to={'/role'}><span>User Role</span></Link>
                {watch("name") ? <span>{watch("name")}</span> : ""}
                <span>{id ? "Update" : "Create"}</span>
                {/* {id ? <span>{id}</span> : ""} */}
            </div>
            <Card className="p-3 instreamRows">
                <h6 className="title">{id ? `Update` : `Create`} User Role</h6>
                <span className="text-danger mb-5" style={{ fontSize: "12px" }}>All fields marked with * are mandatory</span>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Card className="p-3">
                        <h6 className="subTitle">User Role Information</h6>
                        <Row>
                            <Col md={3}>
                                <label>Custom Role<span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <Form.Control
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    placeholder="Enter here..."
                                    {...register("name", {
                                        required: "Account Name is required",
                                        minLength: {
                                            value: 5,
                                            message: "Custom Role must be at least 5 characters"
                                        },
                                        maxLength: {
                                            value: 30,
                                            message: "Custom Role not more then 30 characters"
                                        },
                                        validate: value =>
                                            value.trim() !== "" || "cannot be empty spaces",
                                    })}
                                />
                                {errors.name && <p className="text-danger">{errors.name.message}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Account Type<span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <select
                                    className="form-select"
                                    name="accountType"
                                    {...register("accountType", { required: "Account Name is required" })}>
                                    <option value="">Please Select</option>
                                    {accountList?.map((item, index) => {
                                        return (
                                            <option key={index} value={item?.id}>{item?.name}</option>
                                        )
                                    })}
                                </select>
                                {errors.accountType && <p className="text-danger">{errors.accountType.message}</p>}
                            </Col>
                        </Row>
                    </Card>

                    <Card className="p-3 mt-5">
                        <h6 className="subTitle">Permissions</h6>

                        {/* Info banner when ALL PERMISSIONS is active */}
                        {isAllPermissionsSelected && (
                            <div
                                className="alert alert-info mt-2"
                                style={{ fontSize: "13px" }}>
                                ℹ️ <strong>All Permissions</strong> is selected. Other permission groups are hidden. Uncheck to configure individually.
                            </div>
                        )}

                        {visibleGroups.map((group, index) => {
                            // Use original index from permissionGroups for stable eventKey
                            const originalIndex = permissionGroups.findIndex(g => g.moduleName === group.moduleName);
                            const eventKey = originalIndex.toString();
                            const isOpen = openKeys.includes(eventKey);

                            return (
                                <Card key={originalIndex} className="p-3 mt-5">
                                    <CustomToggle
                                        eventKey={eventKey}
                                        isOpen={isOpen}
                                        onToggle={() => handleToggle(eventKey)}>
                                        {/* {group.moduleName} */}
                                        {group.displayName}
                                    </CustomToggle>

                                    {isOpen && (
                                        <div className="mt-3" style={{ paddingLeft: "35px", display: "flex", flexFlow: "row wrap" }}>
                                            {group.permissions.map((item, i) => (
                                                <div key={i} style={{ marginBottom: "20px", marginRight: "35px" }}>
                                                    <Form.Check
                                                        type="checkbox"
                                                        label={item?.label}
                                                        value={JSON.stringify(item)}
                                                        {...register("permissions")}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </Card>
                            );
                        })}
                    </Card>

                    {
                        id ?
                            <Row className="mt-3">
                                <Col>
                                    <div className="switch-container">
                                        <span>Force Update</span>

                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                checked={forceUpdate}
                                                onChange={(e) => setForceUpdate(e.target.checked)}
                                            />
                                            <span className="slider"></span>
                                        </label>
                                    </div>

                                    <small className="text-muted">
                                        When enabled, changes will be ignored and the data will be saved forcefully.
                                    </small>
                                </Col>
                            </Row>
                            : null
                    }

                    <Button type="submit" disabled = {btnClicked} variant={forceUpdate ? "dark" : "primary"} className="mt-3 submitBtn" size="lg">
                        {forceUpdate ? "Force Update" : id ? `Update` : `Create`} Role
                    </Button>
                    <Button type="button" variant="secondary" className="mx-5 mt-3 cancelBtn" onClick={redirect}>
                        Cancel
                    </Button>
                </form>
            </Card >
        </FormLoader >
    );
}

export default CreateUserRole;